<template>
  <div
    class="widget"
    :class="dynamicClasses">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Widget',

  props: {
    // name
    name: String
  },

  computed: {
    // dynamic classes
    dynamicClasses () {
      return this.name ? `widget--${this.name}` : ''
    }
  }
}
</script>

<style scoped>
.widget {
  position: relative;
}
</style>